import React from "react";
import { Icon as LucideIcon } from "../../Common/Icons/LucideIcons";
import {
  AssistantHeader,
  AssistantName,
  IntroContainer,
  IntroText,
  MessageContent,
  SuggestionButton,
  SuggestionIconWrapper,
  SuggestionsContainer,
  SuggestionsTitle,
  SuggestionText,
} from "./__styles__/AssistantIntro";

export interface AssistantIntroProps {
  onSuggestionClick: (suggestion: string) => void;
}

const DEFAULT_SUGGESTIONS = [
  {
    text: "Describe property conditions and fill out the inspection form accordingly",
    iconName: "align-justify" as const,
  },
  {
    text: "Create a Notice of Violation letter based on this inspection",
    iconName: "file" as const,
  },
];

const AssistantIntro: React.FC<AssistantIntroProps> = ({
  onSuggestionClick,
}) => {
  return (
    <IntroContainer>
      <AssistantHeader>
        <LucideIcon iconName="sparkles" color="contentPrimary" size={14} />
        <AssistantName>Assistant</AssistantName>
      </AssistantHeader>

      <MessageContent>
        <IntroText>
          What can we work on together? I'm powered by AI, so surprises and
          mistakes are possible. Make sure to review any generated information
          or suggestions, and share feedback so that we can learn and improve.
        </IntroText>

        <SuggestionsContainer>
          <SuggestionsTitle>SUGGESTIONS</SuggestionsTitle>
          {DEFAULT_SUGGESTIONS.map((suggestion, index) => (
            <SuggestionButton
              key={index}
              onClick={() => onSuggestionClick(suggestion.text)}
            >
              <SuggestionIconWrapper>
                <LucideIcon
                  iconName={suggestion.iconName}
                  color="contentPrimary"
                  size={16}
                />
              </SuggestionIconWrapper>
              <SuggestionText>{suggestion.text}</SuggestionText>
            </SuggestionButton>
          ))}
        </SuggestionsContainer>
      </MessageContent>
    </IntroContainer>
  );
};

export default AssistantIntro;
